import template from './employee_add_linked_leave_by_category.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeCreateLinkLeaveByCategoryViewModel
{
	constructor(dialog)
	{
		this.dialog = dialog
		this.ll_date_start = ko.observable()
		this.allowed_values = ko.observableArray([ko.observable('')])
		this.ll_cycle_date = ko.observable()
		this.available_leave_categories = ko.observableArray()
		this.selected_category = ko.observable()

		this.ll_date_start.subscribe((val) => {
			if (this.ll_date_start() && this.ll_cycle_date()) {
				if (this.ll_date_start() > this.ll_cycle_date()) this.ll_cycle_date(val)
			}
		})

		this.ll_cycle_date.subscribe((val) => {
			if (this.ll_date_start() && this.ll_cycle_date()) {
				if (this.ll_date_start() > this.ll_cycle_date()) this.ll_date_start(val)
			}
		})
	}


	close()
	{
		this.dialog.close()
	}

	async save_linked_leave()
	{

		if (!this.has_valid_dates())
		{
			Grape.alerts.alert({
				type: 'error',
				message: tr('Please select both start date and cycle start date.', 'Please select both start date and cycle start date.'),
				title: tr('Error', 'Error'),
			})
			return
		}
		let obj = {
			category: this.selected_category(),
			employee_id: this.dialog.bindings.employee_id,
			date_start: this.ll_date_start(),
			cycle_date_start: this.ll_cycle_date(),
		}

		let res = await Grape.fetches.postJSON('/employee/save_linked_leave_by_category', obj)

		if (res.status == 'OK') {
			Grape.alerts.alert({ type: 'success', message: tr('Successfully added linked leave.'), title: tr('Success', 'Success') })
			this.dialog.close()
		} else if (res.status == 'ERROR') Grape.alerts.apiError(res)
		else Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') })
	}

	is_valid_date (date)
	{
		return date instanceof Date && !isNaN(date)
	}

	has_valid_dates ()
	{
		let start_date = this.ll_date_start()
		let cycle_date = this.ll_cycle_date()
		return this.is_valid_date(new Date(start_date)) && this.is_valid_date(new Date(cycle_date))
	}
};

class EmployeeCreateLinkedLeaveByCategoryPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeCreateLinkLeaveByCategoryViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		let res = await Grape.fetches.getJSON('/api/record', { table: 'leave_category', limit: 1000000 });
		if (res.status !== 'ERROR')
		{
			this.viewModel.available_leave_categories(res.records);

			let ei = ko.mapping.toJS(this.bindings.employment_info);
			let start_date = '';
			for (let a = 0; a < ei.length; a++)
			{
				if (ei[a].active == true)
				{
					start_date = ei[a].date_started;
					break;
				}
			}

			if (start_date != '')
			{
				let mydate = new Date(start_date);
				mydate.setDate(25);

				if (mydate < new Date(start_date))
					mydate.setMonth(mydate.getMonth() + 1);

				this.viewModel.ll_date_start(Utils.toJSONDateString(new Date(start_date)));
				this.viewModel.ll_cycle_date(Utils.toJSONDateString(new Date(start_date)));
			}
		}
		else
		{
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'Error', message: tr('Could not load leave categories...')});
		}
	};
};

export default {
	name: 'EmployeeAddLinkedLeaveByCategory',
	dialog_class: EmployeeCreateLinkedLeaveByCategoryPage,
	template: template,
	template_filename: 'translation/dialogs/employee_add_linked_leave_by_category',
	provider: 'ps'
};
